<template>
  <div>
    <div class="p-5 bg-white rounded non-print">
      <div class="py-6 text-xl text-center">{{ $t('suspend.report_suspend_business') }}</div>
      <between-date @onClick="initData"></between-date>
      <div class="flex justify-end py-3">
        <v-btn class="blue white--text mx-1" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
        <!-- <v-btn class="blue white--text mx-1" @click="printPDF">
          <v-icon left>mdi-file-excel</v-icon>พิมพ์ PDF
        </v-btn> -->
      </div>
      <div>
        <div class="d-flex justify-center py-10" v-if="isLoading">
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </div>
        <v-data-table
          v-if="dataTable && !isLoading"
          :headers="dataTable.headers"
          :items="dataTable.data"
          :items-per-page="itemsPerPage"
          class="elevation-1 report-suspend-table v-data-table-report"
          item-key="objectId"
          v-model="selectedContracts"
          :show-select="isShowSelectContract"
          :single-select="false"
          id="printarea"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <template v-for="item, index in items">
                <tr :key="index" class="disable">
                  <td class="text-center">{{ item.name }}</td>
                  <td v-for="header in dataTable.headers.filter(d => d.type == 'data')" class="text-center" :key="header.text" :class="header.date > $moment() ? 'disable' : '' ">
                    <template v-if="header.hashContractSuspend[item.objectId] && !header.hashAreaBooking[item.objectId]">
                      <v-icon v-if="header.hashContractSuspend[item.objectId].type == 'late'" color="warning">mdi-alert-circle-outline</v-icon>
                      <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
                    </template>
                    <template v-else>
                      <v-icon v-if="
                        header.hashContract[item.objectId] || 
                        header.hashContractCheckout[item.objectId] || 
                        header.hashAreaBooking[item.objectId]" color="blue">mdi-check</v-icon>
                    </template>
                  </td>
                </tr>
              </template>
              <tr class="font-bold">
                <td>{{ $t('market.late') }}</td>
                <td v-for="header in dataTable.headers.filter(d => d.type == 'data')" class="text-center" :key="header.text">
                  {{ header.late }}
                </td>
              </tr>
              <tr class="font-bold">
                <td>{{ $t('market.absent') }}</td>
                <td v-for="header in dataTable.headers.filter(d => d.type == 'data')" class="text-center" :key="header.text">
                  {{ header.absent }}
                </td>
              </tr>
              <tr class="font-bold">
                <td>{{ $t('sum') }}</td>
                <td v-for="header in dataTable.headers.filter(d => d.type == 'data')" class="text-center" :key="header.text">
                  {{ header.summary }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import BetweenDate from "./BetweenDate.vue";
import DocumentEditorDialog from "../components/DocumentEditorDialog.component.vue"
import { Excel } from "../exports";
import { mapState } from "vuex";
export default {
  components: { 
    BetweenDate,
    DocumentEditorDialog
  },
  computed:{
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    userFullName() {
      return this.$store.getters["user/getFullName"];
    },
    ...mapState({
      areas: state => state.area.areas,
      contractSuspends: state => state.contractSuspend.contractSuspends,
    }),
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      contracts: null,
      isShowSelectContract: false,
      selectedContracts: [],
      project: null,
      market: null,
      templates: null,
      isContractTemplateDialog: false,
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      itemsPerPage: 10,
      dataTable: {
        headers: [],
        data: []
      },
      contracts: [],
      contractCheckouts: [],
      areaBookings: [],
      summary: []
    };
  },
  created(){
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.dataTable.headers = [
      {
        text: this.$t('date'),
        value: "startDate",
        align: "center",
        width: "15%"
      },
    ]
  },
  mounted(){
    this.initData()
  },
  methods: {
    async initData(date) {
      this.isLoading = true
      try{
        let startDate = date ? date.startDate : this.$moment(this.startDate).startOf("day").toISOString()
        let endDate = date ? date.endDate : this.$moment(this.endDate).endOf("day").toISOString()
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
        await this.$store.dispatch("contractSuspend/getContractSuspendBetweenDateByMarket", {
          marketId: this.marketId,
          startDate,
          endDate
        });
        this.contracts = await this.$store.dispatch("contract/getActiveContractsBetweenDateByMarket", {
          marketId: this.marketId,
          startDate,
          endDate
        });
        this.contractCheckouts = await this.$store.dispatch("contractCheckout/getContractCheckoutsStatusDateBetweenDateByMarket",{
          marketId: this.marketId,
          startDate,
          endDate,
          isReduce: true
        });
        this.areaBookings = await this.$store.dispatch("areaBooking/getAreaBookingCheckedInDateBetweenDate",{
          marketId: this.marketId,
          startDate,
          endDate
        });
        this.dataTable.headers = [
          {
            text: this.$t('date'),
            value: "name",
            align: "center",
            width: "15%"
          }
        ]
        let days = this.$moment(endDate).diff(startDate, "days")
        
        for(let i = 0; i <= days; i++){
          let hashContractSuspend = {}
          let hashContract = {}
          let hashContractCheckout = {}
          let hashAreaBooking = {}
          let summaryArea = []
          let date = this.$moment(startDate).add(i, "days")

          let contracts = this.contracts.filter(d => 
            (
              !d.isActive && (d.createdAt && d.closeContractAt) &&
              this.$moment(d.createdAt) <= this.$moment(date).endOf("day") &&
              this.$moment(d.closeContractAt.iso) >= this.$moment(date).startOf("day")
            )
              ||
            (
              d.isActive && (d.createdAt) &&
              this.$moment(d.createdAt) <= this.$moment(date).endOf("day")
            )
          )
          for(let contract of contracts){
            for(let area of contract.areas || []){
              hashContract[area.objectId] = contract
              if(summaryArea.indexOf(area.objectId) == -1) summaryArea.push(area.objectId)
            }
          }

          let contractCheckouts = this.contractCheckouts.filter(d => 
            (
              (d.statusUpdatedAt && d.contract.createdAt) &&
              this.$moment(d.contract.createdAt) <= this.$moment(date).startOf("day") &&
              this.$moment(d.statusUpdatedAt).endOf("day") >= this.$moment(date).endOf("day")
            )
          )
          for(let contractCheckout of contractCheckouts){
            for(let area of contractCheckout.areas || []){
              hashContractCheckout[area.objectId] = contractCheckout
              if(summaryArea.indexOf(area.objectId) == -1) summaryArea.push(area.objectId)
            }
          }

          let areaBookings = this.areaBookings.filter(d => 
            (
              d.checkedOutDate && d.checkedInDate &&
              this.$moment(d.checkedInDate.iso) <= this.$moment(date).endOf("day") &&
              this.$moment(d.checkedOutDate.iso) >= this.$moment(date).startOf("day")
            )
              ||
            (
              !d.checkedOutDate && d.checkedInDate &&
              this.$moment(d.checkedInDate.iso) <= this.$moment(date).endOf("day")
            )
          )
          for(let areaBooking of areaBookings){
            hashAreaBooking[areaBooking.area.objectId] = areaBooking
            if(summaryArea.indexOf(areaBooking.area.objectId) == -1) summaryArea.push(areaBooking.area.objectId)
          }

          let contractSuspends = this.contractSuspends.filter(d => 
            (
              d.isSuspend && (d.startDate && d.cancelledDate) &&
              this.$moment(d.startDate.iso) <= this.$moment(date).endOf("day") &&
              this.$moment(d.cancelledDate.iso) >= this.$moment(date).endOf("day")
            )
              ||
            (
              d.isSuspend && (d.startDate && d.endDate && !d.cancelledDate) &&
              this.$moment(d.startDate.iso) <= this.$moment(date).endOf("day") &&
              this.$moment(d.endDate.iso) >= this.$moment(date).startOf("day")
            )
              ||
            (
              !d.isSuspend && d.issueDate && d.type == 'late' &&
              this.$moment(d.issueDate.iso) >= this.$moment(date).startOf("day") &&
              this.$moment(d.issueDate.iso) <= this.$moment(date).endOf("day")
            )
          )
          for(let contractSuspend of contractSuspends){
            for(let area of contractSuspend.contract.areas || []){
              if(hashContract[area.objectId] && hashContract[area.objectId].objectId == contractSuspend.contract.objectId){
                hashContractSuspend[area.objectId] = contractSuspend
                if(!hashAreaBooking[area.objectId]) summaryArea = summaryArea.filter(d => d != area.objectId)
              }
            }
          }

          let late = 0
          let absent = 0
          for(let key in hashContractSuspend){
            if(hashContractSuspend[key].type == "late") late++
            else if(!hashAreaBooking[key]) absent++
          }
          if(date >= this.$moment()){
            this.dataTable.headers.push({
              text: date.format("DMMMYY"),
              align: "center",
              type: "data",
              date: date,
              hashContractSuspend: {},
              hashContract: {},
              hashContractCheckout: {},
              hashAreaBooking: {},
              late: 0,
              absent: 0,
              summary: 0,
              sortable: false,
            })
          }else{
            this.dataTable.headers.push({
              text: date.format("DMMMYY"),
              align: "center",
              type: "data",
              date: date,
              hashContractSuspend,
              hashContract,
              hashContractCheckout,
              hashAreaBooking,
              late,
              absent,
              summary: summaryArea.length,
              sortable: false,
            })
          }
        }
        this.dataTable.data = this.areas || []
        this.isLoading = false
      }catch(err){
        console.log(err)
        this.isLoading = false
        this.$toast.show({
          content: `${this.$t('error')}`,
          color: "error"
        });
      }
    },
    exportExcel(){
      Excel.reportSuspend(this.dataTable.headers, this.areas, this.startDate, this.endDate)
    },
    printPDF(){
      const tempItemsPerPage = this.itemsPerPage
      this.itemsPerPage = -1
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('customer.customer_move_in')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${ this.$moment(this.startDate, "YYYY-MM-DD").format("D MMMM YYYY") } - ${this.$moment(this.endDate, "YYYY-MM-DD").format("D MMMM YYYY")}
          </p>
        `
        printPreviewcontent.innerHTML = printarea
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName} <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`
        window.print();
        this.itemsPerPage = tempItemsPerPage
      }, 200)
    }
  },
};
</script>
<style  lang="scss">
.report-suspend-table{
  td.disable{
    background: #f5f5f5;
  }
}
.report-suspend-table{
  td:nth-child(1) {
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 2 !important;
    box-shadow: 2px 2px 2px gray !important;
  }
  th:nth-child(1){
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 3 !important;
  }
}
</style>